import { Dropdown, Button } from "antd";
import { useEffect, useState } from "react";
import { FaCalendarAlt, FaSyringe, FaShieldAlt, FaBriefcaseMedical } from "react-icons/fa";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../components/modelpopup/EmployeeLeaveModelPopup";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { getLeaveRequestsThunk, updateLeaveStatusThunk } from "../../../Slices/LeavesSlice";


const EmployeeLeave = () => {

  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

  const [leaveData, setLeaveData] = useState();
  const allLeaves = useSelector((state) => state?.leaves?.leaves ?? []);
  const dispatch = useDispatch();
  const userId = loginUser?.id;
  useEffect(() => {
    dispatch(getLeaveRequestsThunk({ employeeId: userId }));
  }, [dispatch, userId]);



  const formatDate = (timestamp) => {
    return timestamp ? dayjs(timestamp).format("DD/MM/YYYY") : "N/A";
  };

  const format_date = (timestamp) => {
  if (!timestamp) return "N/A";

  const ts = Number(timestamp);

  return dayjs(ts).format("DD/MM/YYYY");
};
 const formatDateTime = (timestamp) => {
  if (!timestamp) return "N/A";
  return dayjs(Number(timestamp)).format("DD/MM/YYYY hh:mm A");
};

const [pagination, setPagination] = useState({
  current: 1,
  pageSize: 50,
});


  const sortedLeaves = [...allLeaves]?.sort((a, b) => Number(b.createdAt) - Number(a.createdAt))?.filter((leave) => leave?.status !== "false");

  const tableData = sortedLeaves?.map((leave, index) => ({
    key: index,
    leaveType: leave?.leaveType,
    leaveId: leave?._id,
    createdAt: leave?.createdAt,  
    startDate: leave?.startDate,
    endDate: leave?.endDate,
    noOfDays: leave?.leaveDays,
    leaveReason: leave?.leaveReason,
    leaveStatus: leave?.leaveStatus,
    approvedBy: leave?.approvedBy,
    updatedAt: leave?.updatedAt,
    remarks: leave?.remarks,
    session1: leave?.session1,
    session2: leave?.session2,
  }));

  const total = tableData.length;

const pageSizeOptions =
  total <= 50
    ? ["50"]
    : total <= 100
      ? ["50", "100"]
      : total <= 150
        ? ["50", "100", "150"]
        : ["50", "100", "150", "200"];

        const handlePageChange = (page, pageSize) => {
  setPagination({
    current: page,
    pageSize: pageSize,
  });
};
const paginatedData = tableData.slice(
  (pagination.current - 1) * pagination.pageSize,
  pagination.current * pagination.pageSize
);

useEffect(() => {
  setPagination((prev) => ({ ...prev, current: 1 }));
}, [allLeaves]);


  const columns = [
    {
      title: "Leave Type",
      dataIndex: "leaveType",
      key: "leaveType",
    },
    {
  title: "Created At",
  dataIndex: "createdAt",
  key: "createdAt",
  render: (date) => format_date(date),
},

    {
      title: "From",
      dataIndex: "startDate",
      key: "startDate",
      render: (date) => formatDate(date),
    },
    {
      title: "To",
      dataIndex: "endDate",
      key: "endDate",
      render: (date) => formatDate(date),
    },
    {
      title: "No Of Days",
      dataIndex: "noOfDays",
      key: "noOfDays",
    },
    {
      title: "Reason",
      dataIndex: "leaveReason",
      key: "leaveReason",
    },
    {
      title: "Leave Status",
      dataIndex: "leaveStatus",
      key: "leaveStatus",
      render: (text) => {
        if (text === "Declined") return <span style={{ color: "#EF4444", fontWeight: 500 }}>Rejected</span>;
        return text;
      }
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      key: "approvedBy",
      width: 180
    },
    {
  title: "Approved At",
  dataIndex: "approvedAt",
  width: 200,
  render: (text, record) => {
    if (record.leaveStatus === "Pending") return "-";
    const time = record.updatedAt;
    return formatDateTime(time);
  }
},
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => {
        const actionItems = [
          {
            key: 'edit',
            label: 'Edit',
            disabled: record.leaveStatus !== 'Pending',
            onClick: () => handleEditClick(record),
          },
          {
            key: 'delete',
            label: 'Delete',
            danger: true,
            disabled: record.leaveStatus !== 'Pending',
            onClick: () => handleDeleteClick(record),
          },
        ];
        const isDisabled = record.leaveStatus !== 'Pending';
        return (
         <Dropdown menu={{ items: actionItems }} trigger={['click']} disabled={isDisabled}>
           <Button>
             Actions
           </Button>
         </Dropdown>
        );
      },
    },
  ];

  const utilizedLeaves = {
    annual: 0,   
    medical: 0,
    casual: 0,
    other: 0,
  };

  // Loop through allLeaves and count approved leaves
  allLeaves.forEach((leave) => {
    if (leave.leaveStatus === "Approved") {
      const days = parseFloat(leave.approvedDays) || 0;
      switch (leave.leaveType) {
        case "Sick Leave":
          utilizedLeaves.medical += days;
          break;
        case "Casual Leave":
          utilizedLeaves.casual += days;
          break;
        case "Paid Leave":
          utilizedLeaves.other += days;
          break;
        default:
           
          break;
      }
    }
  });

  // Compute annual utilized leaves as sum of all types
  utilizedLeaves.annual = utilizedLeaves.medical + utilizedLeaves.casual + utilizedLeaves.other;

  const currentYear = new Date().getFullYear();
  const employeeLeavesData=loginUser?.leavesSettings?.find( (setting) => setting.year === String(currentYear) && setting.department === loginUser?.department ) || {};
  const totalCasualLeaves =employeeLeavesData?.casualLeaves || 0;
  const totalMedicalLeaves =employeeLeavesData?.medicalLeave || 0;
  const leaveStats = [
    {
      id: 1,
      title: "Annual Leaves(Utilized)",
      value: utilizedLeaves.annual,
      remainingValue:
        (parseFloat(totalCasualLeaves) || 0) +
        (parseFloat(totalMedicalLeaves) || 0) - utilizedLeaves.annual,
      color: "#007BFF",
      badgeColor: "#E5F4FF",
      textColor: "rgb(0, 123, 255)",
      icon: <FaCalendarAlt color="white" size={18} />,
    },
    {
      id: 2,
      title: "Medical Leaves(Utilized)",
      value: utilizedLeaves.medical,
      remainingValue:
        (parseFloat(totalMedicalLeaves) || 0) - utilizedLeaves.medical,
      color: "#007BFF",
      badgeColor: "#E5F4FF",
      textColor: "rgb(0, 123, 255)",
      icon: <FaSyringe color="white" size={18} />,
    },
    {
      id: 3,
      title: "Casual Leaves(Utilized)",
      value: utilizedLeaves.casual,
      remainingValue:
        (parseFloat(totalCasualLeaves) || 0) - utilizedLeaves.casual,
      color: "#007BFF",
      badgeColor: "#E5F4FF",
      textColor: "rgb(0, 123, 255)",
      icon: <FaShieldAlt color="white" size={18} />,
    },
    {
      id: 4,
      title: "Other Leaves(Utilized)",
      value: utilizedLeaves.other,
      remainingValue:
        (parseFloat(loginUser?.otherLeavesAvailable) || 0) - utilizedLeaves.other,
      color: "#007BFF",
      badgeColor: "#E5F4FF",
      textColor: "rgb(0, 123, 255)",
      icon: <FaBriefcaseMedical color="white" size={18} />,
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const handleEditClick = (record) => {
    setSelectedLeave(record); // Set selected leave data for editing
    setIsModalOpen(true); // Open the modal
  };

  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedLeave(null); // Clear selected leave data
  };

  const handleDeleteClick = (record) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this leave record?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const leaveUpdateInput = {
          leaveId: record.leaveId,
          status: "false", // Mark the leave as deleted
        };

        dispatch(updateLeaveStatusThunk([leaveUpdateInput]))
        dispatch(updateLeaveStatusThunk([leaveUpdateInput]))
          .unwrap()
          .then(() => {
            dispatch(getLeaveRequestsThunk({ employeeId: userId }));
          })
          .catch((err) => {
            console.error("Error updating leave status:", err);
          });
      }

    });
  };

  return (
    <>

      <div id="Leaves_Tab" className="card profile-box flex-fill">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Breadcrumbs
              subtitle="Leaves"
              modal="#add_leave"
              name="Add New"
            />
            <div className="row">
              {leaveStats.map((stat, index) => (
                <div className="col-md-3 mb-3" key={index}>
                  <div
                    className="stats-card"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "15px",
                      borderRadius: "10px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                      background: "#fff",
                      position: "relative",
                    }}
                  >
                    <div
                      className="icon-container"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: stat.color,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    >
                      {stat.icon}
                    </div>
                    <div className="info" style={{ textAlign: "left" }}>
                      <h6 style={{ margin: 0, color: "#666" }}>{stat.title}</h6>
                      <h4 style={{ margin: "5px 0", fontWeight: "bold" }}>{stat.value}</h4>
                      <p
                        style={{
                          background: stat.badgeColor,
                          padding: "3px 8px",
                          borderRadius: "5px",
                          fontSize: "12px",
                          color: stat.textColor,
                          display: "inline-block",
                        }}
                      >
                        Remaining Leaves: {stat.remainingValue}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <CustomGridTable
                    columns={columns}
                    Id="employee-leave-table"
                  dataSource={paginatedData}
pagination={{
  current: pagination.current,
  pageSize: pagination.pageSize,
  total: total,
  showSizeChanger: true,
  pageSizeOptions: pageSizeOptions,
  onChange: handlePageChange,

  showTotal: (total, range) =>
    `${range[0]}-${range[1]} of ${total} items`,
}}

                    rowKey="leaveId"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <EmployeeLeaveModelPopup
          leaveData={selectedLeave} // Pass selected leave data
          isOpen={isModalOpen} // Modal open/close state
          onClose={handleModalClose} // Close function

          allLeaves={allLeaves}
          remainingLeaves={leaveData?.availableLeaves}
        />

        <DeleteModal Name="Delete Leaves" />
      </div>
    </>
  );
};

export default EmployeeLeave;